import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useRef } from "react";
import { getScrollbarWidth } from "@/utils";
type OriginalStyle = {
  overflow: CSSStyleDeclaration["overflow"];
  paddingRight: CSSStyleDeclaration["paddingRight"];
};

// Freezes page scroll while a modal / the mobile nav is open by locking the
// REAL scroll container — `<html>`, which carries `overflow-y-scroll` in
// BaseLayout. Locking anything else (e.g. body) leaves the page scrollable, so
// opening a modal could scroll-jump the document (the focused, portaled modal
// sits at the end of <body>, and the browser scrolls to reveal it) — which
// pushed the scroll-linked hero portfolio cards out of view. The removed
// scrollbar is compensated with body padding to avoid a width reflow.
export const useLockBodyScroll = () => {
  const $ = _c(5);
  const original = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      if (typeof document === "undefined" || original.current) {
        return;
      }
      const html = document.documentElement;
      const body = document.body;
      original.current = {
        overflow: html.style.overflow,
        paddingRight: body.style.paddingRight
      };
      body.style.paddingRight = `${getScrollbarWidth()}px`;
      html.style.overflow = "hidden";
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const lock = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      if (typeof document === "undefined" || !original.current) {
        return;
      }
      document.documentElement.style.overflow = original.current.overflow;
      document.body.style.paddingRight = original.current.paddingRight;
      original.current = null;
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const unlock = t1;
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => unlock;
    t3 = [unlock];
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      lock,
      unlock
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};